// `/respond/{co}/{token}` (M8-ASSESS): the respondent's questionnaire. A public route, outside the
// auth guard like invitations.accept: the token is the key, and a guest has no account at all
// (session-expiry skips `/respond/`).
import { createRoute } from "@tanstack/react-router";
import { RespondPage } from "../features/assess/respond-page";
import { rootRoute } from "./__root";

export const respondRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "respond/$co/$token",
  component: function Respond() {
    const { api } = respondRoute.useRouteContext();
    const { co, token } = respondRoute.useParams();
    return <RespondPage api={api} co={co} token={token} />;
  },
});
